import { backendUrl } from "./backendUrl";

const API_URL = backendUrl("/Api/projects.php");

export async function getProjects() {
  const response = await fetch(API_URL, {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Unable to load projects: ${response.status}`);
  }

  const data = await response.json();

  if (!data.success || !Array.isArray(data.projects)) {
    throw new Error(data.message || "Invalid projects response");
  }

  return data.projects;
}
